import { Box, CircularProgress } from '@mui/material';

export default function LoadingPage() {
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ marginLeft: 'auto', marginRight: 'auto' }}>
        <CircularProgress />
        読み込み中…
      </Box>
    </Box>
  );
}
